import {Component, Input, Output, forwardRef, EventEmitter, OnInit} from '@angular/core';
import {NG_VALUE_ACCESSOR, NG_VALIDATORS} from '@angular/forms';
import {AbstractFieldClass} from '../../../../../components/fields/abstract-field.class';
import {ConstantsService} from '../../../../../services/constants.service';
import {PhoneTransformer} from '../../../../../services/transformer.service';
import {PropertyContactType} from '../../../../../types/data.types';
import {DirectoryService} from '../../../../../services/directory.service';


declare const swal: any;

@Component({
    selector: 'contact-field',
    templateUrl: './contact-field.component.html',
    styleUrls: ['contact-field.component.scss'],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => ContactFieldComponent), multi: true },
        { provide: NG_VALIDATORS, useExisting: forwardRef(() => ContactFieldComponent), multi: true }
    ]
})
export class ContactFieldComponent extends AbstractFieldClass implements OnInit {
    @Input('value') _value = [];
    @Output('reset') resetPhones: EventEmitter<any> = new EventEmitter<any>();
    @Input() title = 'Phones';

    private primaryPhoneIndex: number;
    private originPrimaryPhoneIndex: number;

    private phoneTypes: Array<any> = [
        {type: 'head_office', label: 'Head Office'},
        {type: 'concierge_desc', label: 'Concierge Desc'}
    ];

    constructor(public directoryService: DirectoryService) {
        super();
    }

    ngOnInit() {
        super.ngOnInit();
        this.getCurrentPrimaryState();
    }

    getPhoneTypeLabel(type): string {
        const typeObj = this.phoneTypes.find((i) => i.type === type);
        return typeObj ? typeObj.label : '';
    }

    addNew(): void {
        const isFirst = this.value.length === 0;
        this.value.push(new PropertyContactType(isFirst));

        if (isFirst) {
            this.getCurrentPrimaryState();
        }

        this.propagateChange(this.value);
        this.editModeOn();
    }

    delete(index): void {
        swal(ConstantsService.getSwalConfig('Delete Phone'), () => {
            if (index === 0 && this.value[index].isPrimary && this.value[1]) {
                this.updatePrimary(1);
            }
            if (this.value[index].isPrimary) {
                this.updatePrimary(0);
            }
            this.value.splice(index, 1);
            this.propagateChange(this.value);
            this.apply();
        });
    }

    public updatePhone(value, index): void {
        this.value[index].phone = value;
        this.propagateChange(this.value);
    }

    public updateType(value, index): void {
        this.value[index].contactType = value;
        this.propagateChange(this.value);
    }

    public validateValue(event) {

        return event.charCode >= 48 && event.charCode <= 57;
    }

    private updatePrimary(index): void {
        if (!this.value.length) return;
        this.resetPrimaryState();
        this.value[index].isPrimary = true;
        this.propagateChange(this.value);
    }

    getPhone(data: any) {
        return PhoneTransformer.stringToPhone(data.phone);
    }

    preparePhoneForInput(data: any) {
        return PhoneTransformer.phoneToString(data.phone);
    }

    private resetPrimaryState(): void {
        this.value.forEach((item) => {
            item.isPrimary = false;
        });
    }

    private getCurrentPrimaryState(): void {
        if (this.value.length === 1) {
            this.primaryPhoneIndex = 0;
            this.originPrimaryPhoneIndex = 0;
            this.updatePrimary(0);
            return;
        }
        const index = this.getPrimaryIndex();
        this.primaryPhoneIndex = index;
        this.originPrimaryPhoneIndex = index;

        return;
    }

    public getPrimaryIndex() {
        return this.value.findIndex(v => v.isPrimary);
    }

    apply(): void {
        this.prepareDataBeforeApply(this.value);

        super.apply();
        this.getCurrentPrimaryState();
    }

    copyValue(): void {
        super.copyValue();
    }

    reset(): void {
        super.reset();
        this.primaryPhoneIndex = this.originPrimaryPhoneIndex;

        this.propagateChange(this.value);

        this.resetPhones.emit(this.value);
    }

    validator(value: any): boolean {
        return undefined;
    }

    prepareDataBeforeApply(data: Array<any>): void {
        this.value = this.value.filter((item) => {
            if (!item.phone) {
                if (item.isPrimary) {
                    this.value[0].isPrimary = true;
                }

                return false;
            }

            return true;
        });
    }

}




// WEBPACK FOOTER //
// /app/src/app/views/admin/property/item-view/contact-field/contact-field.component.ts